export default __webpack_public_path__ + "static/media/uil_import.1850bd0a.svg";